var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-default ls-flex-column fill" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "pagetitle h3" }, [
        _vm._v(_vm._s(_vm._f("translate")("Quick edit")))
      ]),
      _c("div", {}, [
        _c(
          "div",
          { staticClass: "ls-flex-row align-content-space-between wrap" },
          [
            _c("div", { staticClass: "col-5" }, [
              _c("div", { staticClass: "ls-flex-row" }, [
                _c(
                  "label",
                  {
                    staticClass: "ls-flex col-6",
                    attrs: { for: _vm.type + "--Select-Delimiter" }
                  },
                  [_vm._v(_vm._s(_vm._f("translate")("Select delimiter")))]
                ),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.delimiter,
                        expression: "delimiter"
                      }
                    ],
                    staticClass: "form-control ls-flex",
                    attrs: { id: _vm.type + "--Select-Delimiter" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.delimiter = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: ";" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm._f("translate")("Semicolon")) +
                          " (;)\n                            "
                      )
                    ]),
                    _c("option", { attrs: { value: "," } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm._f("translate")("Comma")) +
                          " (,)\n                            "
                      )
                    ]),
                    _c("option", { domProps: { value: "\t" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm._f("translate")("Tab")) +
                          " (\\t)\n                            "
                      )
                    ])
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "col-5 text-right" }, [
              _c(
                "label",
                { attrs: { for: _vm.type + "--Toggle-Multilingual" } },
                [
                  _vm._v(
                    _vm._s(_vm._f("translate")("Multilingual entry")) + " "
                  )
                ]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.multilanguage,
                    expression: "multilanguage"
                  }
                ],
                attrs: {
                  id: _vm.type + "--Toggle-Multilingual",
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.multilanguage)
                    ? _vm._i(_vm.multilanguage, null) > -1
                    : _vm.multilanguage
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.multilanguage,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.multilanguage = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.multilanguage = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.multilanguage = $$c
                    }
                  }
                }
              })
            ])
          ]
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "panel-body ls-flex-column grow-1 fill" },
      _vm._l(_vm.scales, function(scale) {
        return _c(
          "div",
          {
            key: scale,
            staticClass: "ls-flex-column ls-space margin top-5 bottom-5",
            class: "scoped-fix-height-1-" + _vm.scales.length
          },
          [
            _c("div", { staticClass: "ls-flex-row" }, [
              _c("h3", [
                _vm._v(
                  _vm._s(_vm._f("translate")("Scale")) + " " + _vm._s(scale)
                )
              ])
            ]),
            _c("div", { staticClass: "ls-flex-colum grow-1" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.unparsed[scale],
                    expression: "unparsed[scale]"
                  }
                ],
                staticClass: "scoped-textarea-class",
                domProps: { value: _vm.unparsed[scale] },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    ) {
                      return null
                    }
                    if (
                      $event.ctrlKey ||
                      $event.shiftKey ||
                      $event.altKey ||
                      $event.metaKey
                    ) {
                      return null
                    }
                    return _vm.addTabAtCursor($event)
                  },
                  paste: function($event) {
                    $event.preventDefault()
                    return _vm.onPaste($event, scale)
                  },
                  blur: function($event) {
                    return _vm.parseContent(scale)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.unparsed, scale, $event.target.value)
                  }
                }
              })
            ]),
            _c("div", { staticClass: "ls-flex-row bg-info" }, [
              _c("div", { staticClass: "text-left" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm._f("translate")("New rows")) +
                    ": "
                ),
                _c("span", { staticClass: "badge" }, [
                  _vm._v(_vm._s(_vm.parsed.length))
                ])
              ])
            ])
          ]
        )
      }),
      0
    ),
    _c("div", { staticClass: "panel-footer" }, [
      _c("div", { staticClass: "ls-flex-row wrap" }, [
        _c("div", { staticClass: "ls-flex-item" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary ls-space margin left-5",
              attrs: { type: "button" },
              on: { click: _vm.replaceCurrent }
            },
            [_vm._v(_vm._s(_vm._f("translate")("Replace")))]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-primary ls-space margin left-5",
              attrs: { type: "button" },
              on: { click: _vm.addToCurrent }
            },
            [_vm._v(_vm._s(_vm._f("translate")("Add")))]
          )
        ]),
        _c("div", { staticClass: "ls-flex-item text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-danger ls-space margin right-5",
              attrs: { type: "button" },
              on: { click: _vm.resetContent }
            },
            [_vm._v(_vm._s(_vm._f("translate")("Reset")))]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-danger ls-space margin right-5",
              attrs: { type: "button" },
              on: { click: _vm.close }
            },
            [_vm._v(_vm._s(_vm._f("translate")("Cancel")))]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }